import { EmailOutlined } from "@mui/icons-material";
import { Button, InputAdornment, TextField } from "@mui/material";
import axios from "axios";
import CustomText from "components/typography/CustomText";
import jsPDF from "jspdf";
import "jspdf/dist/polyfills.es.js";
import { currency } from "lib/formatter";
import { SERVER_URL } from "lib/global";
import moment from "moment/moment";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useSelector } from "react-redux";
import { openLoading } from "store/reducers/tools";

export default function SuccessForm({
  data = {},
  onChange = () => {},
  onPrevious = () => {},
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [disabled, setDisabled] = useState(true);
  const app = useSelector((state) => state?.app ?? {});

  const downloadVoucher = () => {
    openLoading(true);
    axios
      .get(`${SERVER_URL}/api/vouchercode/print-pdf`, {
        params: {
          code: app?.code ?? "",
          box_count: app?.count?.id ?? 3,
        },
        responseType: "arraybuffer",
      })
      .then((res, err) => {
        openLoading(false);
        if (res.status === 200) {
          const file = new Blob([res.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.target = "_blank";
          link.download = "voucher.pdf";
          link.href = fileURL;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((err) => {
        console.log("err", err);
        openLoading(false);
      });
  };

  const handleDownloadGST = () => {
    openLoading(true);
    const doc = new jsPDF({ unit: "px", format: "a5" });
    doc.html(
      `<div style="width: 300px; border: 1px solid #ccc; border-radius: 4px; font-size: 10px">
      <p style="border-bottom: 1px solid #ccc; margin: 0; padding: 0px 24px 12px">Pie Club Voucher</p>
      <div style="padding: 16px 24px">
        <p>Fat Bastard Pies Ltd</p>
        <p style="padding-bottom: 5px; padding-top: 5px;">158 Tay Street, Invercargill</p>
        <div style="display: flex; justify-content: space-between;  padding-bottom: 5px;  padding-top: 25px;">         
          <p>Pie Club Voucher</p> 
        </div>
        <div style="border-bottom: 1px solid #ccc;padding-bottom: 12px; display: flex; justify-content: space-between;">
          <p style="margin: 0; padding-left: 10px; flex: 1 1 0%">${
            data?.box_count?.id
          } X Box Deliveries<p/>
          <p style="margin: 0;">${currency.format(data?.box_count?.id * 65)}<p/>
        </div> 
        <div style="display: flex; justify-content: space-between;border-bottom: 1px solid #ccc;padding-bottom: 12px">
          <p>Total</p>
          <div style="display: flex; justify-content: flex-end; flex-direction: column">
            <p>${currency.format(data?.box_count?.id * 65)}</p>
            <p>Inc GST</p>
          </div>
        </div>
        <div style="display: flex; width: 100%">
          <div style="width: 50%"> 
          </div>
          <div style="width: 50%">
            <p>Date : </p>
            <p>${moment().format("MMMM DD, YYYY")}</p>
          </div>
        </div>
        <p style="padding-top: 5px;">Email : </p>
        <p>${data?.email}</p>
        <p style="padding-top: 5px;">Payment Method : </p>
        <p>${`${
          app?.payment_method?.card?.brand?.toUpperCase() ?? "--"
        } (**** **** **** ${app?.payment_method?.card?.last4 ?? ""})`}</p>
        <p style="padding-top: 5px;">GST Number : 125-532-233</p>
      </div>
    </div>`,
      {
        callback: function (doc) {
          openLoading(false);
          doc.save(`GST-Receipt.pdf`);
        },
        x: 7,
        y: 20,
      }
    );
  };

  const resend = () => {
    openLoading(true);
    axios
      .post(`${SERVER_URL}/api/vouchercode/resend`, {
        code: app?.code ?? "",
        box_count: app?.count?.id ?? 3,
        email: data?.email,
        id: app?.id ?? 1,
      })
      .then((res, err) => {
        openLoading(false);
        if (res.status === 200) {
          return enqueueSnackbar("Email Sent!", {
            variant: "success",
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
        openLoading(false);
      });
  };

  // const downloadURI = (uri, name) => {
  //   var link = document.createElement("a");
  //   link.target = "_blank";
  //   link.download = name;
  //   link.href = uri;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  return (
    <div className="bg-secondary px-14 pt-24 pb-14 w-voucher-box rounded-3xl">
      <CustomText className="text-center font-zing text-white text-[58px] uppercase">
        success!
      </CustomText>
      <CustomText className="text-center text-white text-lg uppercase py-5">
        We've emailed your voucher
      </CustomText>
      <CustomText className="text-center text-white text-lg uppercase py-3">
        Didn't receive it? Re-send you voucher to:
      </CustomText>
      <TextField
        type="email"
        name="email"
        value={data?.email ?? ""}
        onChange={onChange}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EmailOutlined fontSize="large" color="secondary" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <CustomText
                className="text-secondary text-lg font-zing cursor-pointer pointer-events-auto"
                onClick={() => setDisabled(false)}
              >
                Edit
              </CustomText>
            </InputAdornment>
          ),
        }}
        fullWidth
      />
      <CustomText
        className="cursor-pointer text-white text-center font-zing text-[22px] pt-10 pb-18"
        onClick={resend}
      >
        Re-send Voucher
      </CustomText>
      <div className="flex justify-center">
        <Button
          className="uppercase px-8 text-[22px] font-zing"
          variant="contained"
          onClick={downloadVoucher}
        >
          download / print voucher
        </Button>
      </div>
      <CustomText
        className="cursor-pointer text-[15px] text-white text-center pt-8"
        onClick={handleDownloadGST}
      >
        Download GST Receipt
      </CustomText>
      <CustomText
        className="text-white text-[13px] pt-6 underline cursor-pointer text-center"
        onClick={onPrevious}
      >
        Back to Previous Page
      </CustomText>
    </div>
  );
}
